import keyBy from 'lodash-es/keyBy';
import uniqBy from 'lodash-es/uniqBy';
import { getTheFirstElementOfArray } from '../../utilities/arraysUtils';
import { PACKAGE_TYPE } from '../../utilities/constants';

const pathNames = [
  { path: 'passes', packageTile: PACKAGE_TYPE.pass },
  { path: 'birthday-packages', packageTile: PACKAGE_TYPE.birthday },
  { path: 'cabanas', packageTile: PACKAGE_TYPE.cabanasAndFlexTrip },
  { path: 'dining', packageTile: PACKAGE_TYPE.dining },
  { path: 'lco', packageTile: PACKAGE_TYPE.lateCheckOut }
];

const getPackagesByKey = reservationPackages => ({
  ...keyBy(
    reservationPackages.filter(pkg => pkg.code != null),
    'code'
  ),
  ...keyBy(
    reservationPackages.filter(pkg => pkg.packageCode != null),
    'packageCode'
  ),
  ...keyBy(
    uniqBy(
      reservationPackages.filter(pkg => pkg.packageGroup != null),
      'packageGroup'
    ),
    'packageGroup'
  )
});

const getSelectedPackageTypeTile = tilePath => {
  return pathNames.find(packageTilePath => packageTilePath.path === tilePath);
};

const updatePackagesStateQuantity = (packageState, title, quantity, setPackageQtyState) => {
  const aux = packageState.map(item => {
    if (item.id === title) item.quantity = quantity;
    return item;
  });
  setPackageQtyState(aux);
};

const getUniqueAddOn = pkg => {
  return getTheFirstElementOfArray(pkg?.addOns);
};

const addOnsMapperNewAPIToOldApi = (addOns, type) => {
  return addOns?.map(addOn => {
    if (!addOn) {
      return null;
    }

    const { content, productCode, maxQuantity } = addOn;

    const { title, subtitle, details, icon, description, packageCode } = content;

    const isPass = type === PACKAGE_TYPE.pass;
    const isBundle = type === PACKAGE_TYPE.bundle;

    const newAddOn = {
      ...addOn,
      ...content,
      ...(isPass && { image: icon }),
      ...(isBundle && { packageDescription: description }),
      packageType: [type],
      packageCode: productCode ?? packageCode,
      bookingEngineDetails: details,
      packageTitle: title,
      headline: title,
      subTitle: subtitle,
      maxPackageLimit: maxQuantity
    };

    delete newAddOn.content;

    return newAddOn;
  });
};

export {
  addOnsMapperNewAPIToOldApi, getPackagesByKey,
  getSelectedPackageTypeTile, getUniqueAddOn, updatePackagesStateQuantity
};

